import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const options = [
  "Motorisation sur volet existant : pose d'un moteur dans le coffre actuel",
  "Pose sur volet neuf : intégration du moteur lors de la fabrication",
  "Adaptation du couple moteur selon le poids et la taille du tablier",
  "Vérification de la compatibilité des coulisses et de l'axe existant",
  "Pose tunnel ou façade : motorisation adaptée à chaque type d'installation",
  "Finition esthétique : coffre et commandes intégrées dans le décor",
];

export default function VoletExistant() {
  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative rounded-xl overflow-hidden border border-brand-border">
            <ImagePlaceholder src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/3b96a670e8c728804e649afecdd6a8ed.jpeg" alt="Comparaison volet manuel et volet motorisé Somfy sur façade" className="w-full h-[340px] md:h-[420px]" loading="lazy" />
          </div>

          <div>
            <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold mb-5">
              Volet existant ou neuf
            </h2>
            <p className="text-brand-text text-base leading-relaxed mb-5">
              Que vous ayez un volet roulant manuel déjà en place ou que vous envisagiez une installation complète avec volet neuf, la motorisation Somfy s'adapte à votre situation. Sur un volet existant, nous posons le moteur tubulaire directement dans l'axe du coffre, en vérifiant la compatibilité des coulisses et des embouts. Dans la plupart des cas, aucune modification structurelle de la baie n'est nécessaire. L'intervention est rapide et ne laisse aucune trace visible.
            </p>
            <p className="text-brand-text text-base leading-relaxed mb-6">
              Sur un volet neuf, la motorisation est intégrée dès la fabrication. Le moteur est choisi en fonction des caractéristiques du tablier, et les commandes sont prévues dès la pose. Cette solution offre l'avantage d'une intégration parfaite, avec un coffre et une finition esthétiques optimisés. Nos techniciens vous conseillent sur le type de pose (tunnel, façade ou sous-linteau) et sur le choix du moteur pour garantir une motorisation durable et silencieuse.
            </p>
            <ul className="space-y-3">
              {options.map((opt) => (
                <li key={opt} className="flex items-start gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-brand-cyan/10 shrink-0 mt-0.5">
                    <i className="ri-check-line text-brand-cyan text-sm"></i>
                  </span>
                  <span className="text-brand-text text-base">{opt}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}